import React, { FC } from "react";
import { BhiDrawer } from "src/UIKit";
import { FormView } from "src/components/FormPart/FormView";
import { CreateAdminApplicationFormDrawerController } from "../../controllers";
import { CreateAdminApplicationForm } from "./CreateAdminApplicationForm";

interface CreateAdminApplicationFormDrawerProps extends CreateAdminApplicationFormDrawerController {}

export const CreateAdminApplicationFormDrawer: FC<CreateAdminApplicationFormDrawerProps> = (props) => {
  const { isOpen, close, initFormData, submit } = props;

  return (
    <BhiDrawer isOpen={isOpen} onClose={close} title={initFormData?.id ? "Update Application" : "Create Application"}>
      {initFormData && <FormView formData={initFormData} component={CreateAdminApplicationForm} onSubmit={(full, dirty) => submit(full, dirty)} />}
    </BhiDrawer>
  );
};
